export default "__VITE_ASSET__C1R0C5pt__"